/* LB Update 68: Such-Vorschlagsseite.
   Beim Klick/Fokus ins Suchfeld oeffnet sich eine Vorschlagsflaeche unter der
   Kopfzeile. Es wird NICHT navigiert - dadurch bleibt der Cursor im Feld und
   die Tastatur am Handy offen. Sobald getippt wird, uebernimmt die normale
   Sofortsuche des Themes. */
(function () {
  'use strict';
  var panel, header, input, ergebnisse, offen = false, rafId = 0, gesperrtBis = 0, nachlauf = [];
  var notbremseId = 0;
  var natNr = 0;        /* LB Update 291 (Auftrag F12-N3): Anfragenummer der nativen schmalen Suche (theme.js PredictiveSearch), siehe init() */
  var escFokus = false; /* LB Update 253 (N2): Fokus-Rueckgabe nach Escape, siehe unten */
  /* LB Update 291 (Auftrag VV-R03): Fokus ins Suchfeld setzen, OHNE das Suchfenster zu oeffnen oder zu suchen (gleicher Weg wie die
     Fokus-Rueckgabe nach Escape, LB 253). Genutzt von assets/lb-fix-dialoge.js: Schliesst Escape ein Dialog-Fenster (Newsletter), das
     ueber der aktiven Suche aufging, geht der Fokus ins Feld zurueck - das Suchfenster bleibt dabei zu (das Escape hat es schon geschlossen). */
  window.lbSucheFokusRuhig = function (el) {
    var war = escFokus;
    escFokus = true;
    try { el.focus({ preventScroll: true }); } catch (_) {}
    escFokus = war;
    return document.activeElement === el;
  };

  /* LB Update 202 (Sascha, 23.09.): Am DESKTOP bleibt das Suchfenster beim Tippen
     genau so stehen, wie es sich beim Klick ins Feld oeffnet (Beliebte Kategorien
     links, Kacheln rechts). Die Treffer der normalen Sofortsuche ersetzen nur die
     Kacheln "Beliebte Produkte" - gleiche Karten, gleiche Groesse. Die neuen Kacheln
     werden erst unsichtbar vorbereitet (Bilder geladen) und dann in einem Schritt
     getauscht; bis dahin bleibt das Bisherige stehen. Kein weisser Zwischenzustand,
     kein Umklappen. Die schmale Trefferliste des Themes wird am Desktop nicht mehr
     gezeigt. Feld leer -> sofort wieder die Beliebten Produkte.
     Am Handy bleibt alles wie bisher. */
  function desktop() { return window.matchMedia && window.matchMedia('(min-width: 769px)').matches; }
  var su = { nr: 0, timer: 0, cache: {}, orig: null, grid: null, h: null, btn: null, hText: '', bText: '', bHref: '', q: '' };
  /* LB Update 291 (Auftrag F05): Hoechstdauer eines Abrufs. Danach gilt er als fehlgeschlagen (Fehlerzustand mit Wiederholen-Knopf). */
  var SU_ZEIT = 10000;
  function sprache() { return ((document.documentElement.lang || 'de').slice(0, 2)); }
  function wort(k) {
    var w = {
      de: { t: 'Suchergebnisse', a: 'Alle Ergebnisse', n: 'Keine Produkte gefunden für', f: 'Die Suche konnte nicht geladen werden. Bitte prüfe deine Verbindung und versuche es erneut.', e: 'Erneut versuchen' },
      en: { t: 'Search results', a: 'All results', n: 'No products found for', f: 'The search could not be loaded. Please check your connection and try again.', e: 'Try again' },
      nl: { t: 'Zoekresultaten', a: 'Alle resultaten', n: 'Geen producten gevonden voor', f: 'De zoekopdracht kon niet worden geladen. Controleer je verbinding en probeer het opnieuw.', e: 'Opnieuw proberen' },
      fr: { t: 'Résultats de recherche', a: 'Tous les résultats', n: 'Aucun produit trouvé pour', f: 'La recherche n’a pas pu être chargée. Vérifie ta connexion et réessaie.', e: 'Réessayer' },
      pl: { t: 'Wyniki wyszukiwania', a: 'Wszystkie wyniki', n: 'Nie znaleziono produktów dla', f: 'Nie udało się załadować wyników wyszukiwania. Sprawdź połączenie i spróbuj ponownie.', e: 'Spróbuj ponownie' },
      it: { t: 'Risultati di ricerca', a: 'Tutti i risultati', n: 'Nessun prodotto trovato per', f: 'Impossibile caricare la ricerca. Controlla la connessione e riprova.', e: 'Riprova' },
      es: { t: 'Resultados de búsqueda', a: 'Todos los resultados', n: 'No se encontraron productos para', f: 'No se pudo cargar la búsqueda. Comprueba tu conexión e inténtalo de nuevo.', e: 'Reintentar' }
    };
    return (w[sprache()] || w.de)[k];
  }
  /* LB Update 291 (Auftrag F05): Fehlertext und Knopf kommen aus den Locale-Dateien (lb.search_panel.error / .retry),
     die snippets/lb-suche-panel.liquid als data-Attribute am Suchfenster ablegt. Fehlt der Schluessel
     (Anzeige "translation missing"), gilt der eingebaute Text aus wort(). */
  function lokal(attr, k) {
    var v = panel && panel.getAttribute(attr);
    return (v && v.trim() && !/translation missing/i.test(v)) ? v : wort(k);
  }
  function wurzel() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
  function suVorbereiten() {
    if (su.grid || !panel) return !!su.grid;
    su.grid = panel.querySelector('.lb-suche__grid');
    su.h = panel.querySelector('.lb-suche__produkte .lb-suche__h');
    su.btn = panel.querySelector('.lb-suche__produkte .lb-suche__alle');
    if (!su.grid) return false;
    su.orig = [].slice.call(su.grid.childNodes);
    if (su.h) su.hText = su.h.textContent;
    if (su.btn) { su.bText = su.btn.textContent; su.bHref = su.btn.getAttribute('href'); }
    return true;
  }
  function kinderSetzen(nodes) {
    while (su.grid.firstChild) su.grid.removeChild(su.grid.firstChild);
    for (var i = 0; i < nodes.length; i++) su.grid.appendChild(nodes[i]);
  }
  function suZurueck() {
    su.nr++; clearTimeout(su.timer); su.q = '';
    /* LB Update 291 (Auftrag F05): Laufzustand immer aufraeumen - auch wenn noch keine Treffer standen
       (Feld wurde waehrend des Ladens geleert). Vorher blieb lb-suche--sucht dann dauerhaft stehen. */
    if (panel) panel.classList.remove('lb-suche--sucht');
    if (!su.grid || !su.orig) return;
    su.grid.removeAttribute('aria-busy');
    if (su.grid.getAttribute('data-lb-treffer') == null && su.grid.getAttribute('data-lb-fehler') == null) return;
    su.grid.removeAttribute('data-lb-treffer');
    su.grid.removeAttribute('data-lb-fehler');
    kinderSetzen(su.orig);
    if (su.h) su.h.textContent = su.hText;
    if (su.btn) { su.btn.textContent = su.bText; su.btn.setAttribute('href', su.bHref); su.btn.hidden = false; }
  }
  function holen(q) {
    if (!su.cache[q]) {
      var u = wurzel() + 'search/suggest?q=' + encodeURIComponent(q) +
        '&resources%5Btype%5D=product&resources%5Blimit%5D=10&resources%5Boptions%5D%5Bunavailable_products%5D=last&section_id=lb-suche-treffer';
      /* LB Update 291 (Auftrag F05): Hoechstdauer (AbortController) und Pruefung der Antwort. Nur eine brauchbare
         Antwort (enthaelt .lb-su-treffer) bleibt im Zwischenspeicher; HTTP-Fehler, Timeout, Abbruch, Offline
         und unbrauchbare Antworten werden wieder entfernt, damit dieselbe Anfrage erneut abrufbar ist. */
      var ctrl = window.AbortController ? new AbortController() : null;
      var uhr = setTimeout(function () { if (ctrl) ctrl.abort(); }, SU_ZEIT);
      var p = fetch(u, { credentials: 'same-origin', signal: ctrl ? ctrl.signal : undefined }).then(function (r) {
        if (!r.ok) throw new Error('http');
        return r.text();
      }).then(function (html) {
        var d = new DOMParser().parseFromString(html, 'text/html');
        if (!d.querySelector('.lb-su-treffer')) throw new Error('leer');
        return d;
      }).then(function (d) { clearTimeout(uhr); return d; }, function (e) { clearTimeout(uhr); throw e; });
      su.cache[q] = p;
      p.catch(function () { if (su.cache[q] === p) delete su.cache[q]; });
    }
    return su.cache[q];
  }
  function bilderFertig(box, ms) {
    return new Promise(function (fertig) {
      var imgs = [].slice.call(box.querySelectorAll('img')), offen = 0, ende = false;
      function eins() { offen--; if (offen <= 0 && !ende) { ende = true; fertig(); } }
      imgs.forEach(function (im) {
        if (im.complete && im.naturalWidth) return;
        offen++;
        im.addEventListener('load', eins, { once: true });
        im.addEventListener('error', eins, { once: true });
      });
      if (!offen) { ende = true; fertig(); return; }
      setTimeout(function () { if (!ende) { ende = true; fertig(); } }, ms);
    });
  }
  function suTreffer(q, nr, d) {
    var box = d.querySelector('.lb-su-treffer');
    if (!box) throw new Error('leer');
    var karten = [].slice.call(box.children);
    /* Unsichtbar im Fenster vorbereiten - gleiche Breite wie das echte Gitter,
       damit die Bilder in der richtigen Groesse laden und die Code-Preise schon
       gesetzt werden. */
    var stufe = document.createElement('div');
    stufe.className = 'grid grid--uniform lb-suche__grid lb-suche__stufe';
    stufe.setAttribute('aria-hidden', 'true');
    karten.forEach(function (k) { stufe.appendChild(document.importNode(k, true)); });
    su.grid.parentNode.appendChild(stufe);
    return bilderFertig(stufe, 900).then(function () {
      return new Promise(function (r) { setTimeout(r, document.documentElement.classList.contains('lb-has-discount') ? 120 : 0); });
    }).then(function () {
      var nodes = [].slice.call(stufe.childNodes);
      if (stufe.parentNode) stufe.parentNode.removeChild(stufe);
      if (nr !== su.nr) return;
      su.grid.setAttribute('data-lb-treffer', q);
      su.grid.removeAttribute('data-lb-fehler');
      su.grid.removeAttribute('aria-busy');
      if (!nodes.length) {
        var p = document.createElement('p');
        p.className = 'lb-suche__leer';
        p.setAttribute('role', 'status');
        p.textContent = wort('n') + ' „' + q + '“.';
        nodes = [p];
      }
      kinderSetzen(nodes);
      if (su.h) su.h.textContent = wort('t');
      if (su.btn) {
        su.btn.textContent = wort('a');
        su.btn.setAttribute('href', wurzel() + 'search?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last');
        su.btn.hidden = !karten.length;
      }
      panel.classList.remove('lb-suche--sucht');
    });
  }
  /* LB Update 291 (Auftrag F05): Fehlerzustand fuer die aktuelle Eingabe. Die alten Karten (andere Anfrage) werden
     entfernt, stattdessen steht ein verstaendlicher Text mit "Erneut versuchen". su.q wird zurueckgesetzt, damit
     dieselbe Eingabe (erneutes Tippen, Fokus, Klick, Knopf, wieder online) neu abgerufen wird. */
  function fehlerZeigen(q) {
    su.q = '';
    var box = document.createElement('div');
    box.className = 'lb-suche__leer lb-suche__fehler';
    box.setAttribute('role', 'alert');
    var t = document.createElement('p');
    t.textContent = lokal('data-lb-fehler', 'f');
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'btn btn--secondary btn--small lb-suche__nochmal';
    b.textContent = lokal('data-lb-nochmal', 'e');
    b.addEventListener('click', nochmal);
    box.appendChild(t); box.appendChild(b);
    su.grid.removeAttribute('data-lb-treffer');
    su.grid.setAttribute('data-lb-fehler', q);
    su.grid.removeAttribute('aria-busy');
    kinderSetzen([box]);
    if (su.h) su.h.textContent = wort('t');
    if (su.btn) {
      su.btn.textContent = wort('a');
      su.btn.setAttribute('href', wurzel() + 'search?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last');
      su.btn.hidden = false;
    }
    panel.classList.remove('lb-suche--sucht');
  }
  function nochmal() {
    var q = input ? input.value.trim() : '';
    if (!q || !desktop()) return;
    su.q = '';
    desktopSuche(q, true);
    try { input.focus({ preventScroll: true }); } catch (_) {}
  }
  function desktopSuche(q, sofort) {
    if (!suVorbereiten()) return;
    if (q === su.q) return;
    su.q = q;
    var nr = ++su.nr;
    clearTimeout(su.timer);
    su.timer = setTimeout(function () {
      if (nr !== su.nr) return;
      panel.classList.add('lb-suche--sucht');
      su.grid.setAttribute('aria-busy', 'true');
      holen(q).then(function (d) {
        if (nr !== su.nr) return;
        return suTreffer(q, nr, d);
      }).catch(function () {
        /* Nur die aktuelle Anfrage darf den Zustand setzen - veraltete Antworten/Fehler werden verworfen. */
        if (nr === su.nr) fehlerZeigen(q);
      });
    }, (sofort || su.cache[q]) ? 0 : 160);
  }

  /* LB Update 189: Zwischen dem ersten Buchstaben und den Treffern des Themes
     lagen rund 1000 ms, in denen weder die Vorschlagsflaeche noch eine
     Trefferliste zu sehen war - der Kunde schaute eine Sekunde lang auf die
     Seite dahinter. Die Flaeche bleibt jetzt stehen, bis die Trefferliste des
     Themes wirklich Inhalt hat. Die Notbremse sorgt dafuer, dass sie auch dann
     verschwindet, wenn die Trefferliste ausnahmsweise nie erscheint. */
  function notbremseAus() { if (notbremseId) { clearTimeout(notbremseId); notbremseId = 0; } }
  function notbremse() {
    if (notbremseId) return;
    notbremseId = setTimeout(function () {
      notbremseId = 0;
      if (input && input.value.trim() !== '') schliessen();
    }, 3000);
  }

  /* LB Update 153: Die Sperre nach dem X gilt nur fuer den Fokus, den der Knopf
     selbst zurueckgibt. Tippt der Kunde das Suchfeld erneut an, faellt sie
     sofort - sonst muesste er warten, bis sie von allein ablaeuft. */
  function nachlaufAbbrechen() {
    gesperrtBis = 0;
    while (nachlauf.length) clearTimeout(nachlauf.pop());
  }
  function spaeterSchliessen(ms) { nachlauf.push(setTimeout(schliessen, ms)); }

  function kopfUnterkante() {
    if (!header) return 0;
    var r = header.getBoundingClientRect();
    return Math.max(0, Math.round(r.bottom));
  }
  function setzen() {
    rafId = 0;
    if (!offen) return;
    panel.style.top = kopfUnterkante() + 'px';
  }
  /* LB Update 225 (Sascha): Nach dem Scrollen faehrt die Kopfzeile noch ~0,4 s zurueck an ihren
     Platz. Gemessen wurde nur waehrend des Scrollens - blieb der Wert 0, lag das Suchfenster
     unsichtbar UEBER der Kopfzeile: Menue, Konto, Tasche und das X reagierten nicht.
     Jetzt wird nach dem letzten Scrollen noch zweimal nachgemessen (nach 450 und 900 ms). */
  var nachmessen = [];
  function anfordern() {
    if (!rafId) rafId = requestAnimationFrame(setzen);
    while (nachmessen.length) clearTimeout(nachmessen.pop());
    nachmessen.push(setTimeout(setzen, 450), setTimeout(setzen, 900));
  }

  function oeffnen() {
    if (offen) return;
    /* Kurz nach dem X bleibt zu: der Knopf gibt den Fokus ans Feld zurueck,
       und der Fokus-Aufruf wuerde die Flaeche sonst sofort wieder oeffnen.
       Ein echtes Antippen des Feldes hebt die Sperre vorher auf. */
    if (Date.now() < gesperrtBis) return;
    /* LB Update 291 (Auftrag F05): Ist das Feld leer (z. B. weil der Browser es bei Escape selbst geleert hat),
       duerfen keine Treffer/Fehlermeldung einer frueheren Eingabe stehen bleiben. */
    if (input && input.value.trim() === '') suZurueck();
    offen = true;
    panel.hidden = false;
    panel.setAttribute('aria-hidden', 'false');
    setzen();
    // Die Kopfzeile aendert beim Oeffnen noch ihre Hoehe - deshalb nachmessen
    setTimeout(setzen, 60);
    setTimeout(setzen, 260);
    setTimeout(setzen, 700);
    window.addEventListener('scroll', anfordern, { passive: true });
    window.addEventListener('resize', anfordern);
  }
  function schliessen() {
    notbremseAus();
    if (!offen) return;
    offen = false;
    panel.hidden = true;
    panel.setAttribute('aria-hidden', 'true');
    window.removeEventListener('scroll', anfordern);
    window.removeEventListener('resize', anfordern);
  }
  function pruefen() {
    // Leeres Feld -> Vorschlaege, getipptes Feld -> Sofortsuche
    if (!input) return;
    var q = input.value.trim();
    if (q === '') suZurueck();
    if (q === '' && document.activeElement === input) { notbremseAus(); oeffnen(); return; }
    /* LB 202: Desktop - das Fenster bleibt, die Treffer ersetzen die Kacheln. */
    if (q !== '' && desktop()) {
      notbremseAus();
      nachlaufAbbrechen();
      if (!offen) oeffnen();
      desktopSuche(q);
      return;
    }
    /* LB 189: NICHT mehr sofort schliessen - sonst entsteht die Luecke.
       Geschlossen wird vom Beobachter weiter unten, sobald die Trefferliste
       des Themes Inhalt hat. */
    if (q !== '') notbremse();
  }

  /* LB Update 193: Beim ERSTEN Antippen der Suche standen die acht Kacheln leer da
     und die Bilder fielen erst nach 1-2 s einzeln hinein (Sascha: "flackert").
     Beim zweiten Mal waren sie im Speicher. Jetzt werden die ersten vier Bilder
     - die man beim Oeffnen sofort sieht - im Leerlauf nach dem Seitenaufbau
     vorgeladen. Danach liegen sie fuer alle weiteren Seiten im Browser-Speicher.
     WICHTIG: Die Bilder haben sizes="auto, ...". "auto" gilt nur fuer lazy-Bilder;
     schaltet man auf eager, nimmt der Browser sonst die volle Bildschirmbreite und
     laedt 900-1080 px statt 360-540 px. Deshalb wird sizes vorher auf die echte
     Kachelbreite gesetzt (dieselbe Angabe wie bei den Kategoriekacheln). */
  var vorgeladen = false;
  function vorladen() {
    if (vorgeladen || !panel) return;
    vorgeladen = true;
    var bilder = panel.querySelectorAll('.lb-suche__grid img');
    for (var i = 0; i < bilder.length && i < 4; i++) {
      var im = bilder[i];
      if (im.getAttribute('loading') !== 'lazy') continue;
      if (im.complete && im.naturalWidth) continue;
      /* LB Update 249 (F1): Desktop-Karten sind 25vw - 124px breit (300-px-Spalte + Raender), nicht 25vw. */
      im.setAttribute('sizes', '(min-width: 769px) calc(25vw - 124px), calc(50vw - 25px)');
      im.setAttribute('loading', 'eager');
    }
  }
  function vorladenPlanen() {
    function spaeter() {
      setTimeout(function () {
        if (window.requestIdleCallback) requestIdleCallback(vorladen, { timeout: 4000 });
        else vorladen();
      }, 1500);
    }
    if (document.readyState === 'complete') spaeter();
    else window.addEventListener('load', spaeter, { once: true });
  }

  function init() {
    panel = document.getElementById('LBSuche');
    header = document.getElementById('SiteHeader');
    if (!panel || !header || panel.dataset.lbBereit) return;
    input = header.querySelector('.lb-header-search input[name="q"]') || document.getElementById('Search');
    if (!input) return;
    panel.dataset.lbBereit = '1';
    /* LB Update 291 (Auftrag F12-N3): Die native schmale Suche (assets/theme.js, PredictiveSearch) hat keine Anfragenummer: antwortet eine aeltere
       Anfrage nach einer neueren (oder nach Escape / geleertem Feld), ueberschreibt oder oeffnet sie die Vorschlaege. Hier bekommt nur der Abruf der
       Vorschlagsabschnitte (section_id=search-results) eine Nummer; eine veraltete Antwort - Kopfzeile, Text oder Fehler - wird verworfen (Promise
       bleibt offen, das Theme zeigt dann nichts Falsches an und schliesst auch nichts). Alle anderen Abrufe bleiben unberuehrt. */
    if (!window.lbVorschlagNr && window.fetch) {
      window.lbVorschlagNr = true;
      var fetchAlt = window.fetch;
      window.fetch = function (u) {
        var adr = (typeof u === 'string') ? u : ((u && u.url) || '');
        if (adr.indexOf('/search/suggest') < 0 || adr.indexOf('section_id=search-results') < 0) return fetchAlt.apply(this, arguments);
        var meine = ++natNr;
        function veraltet() { return new Promise(function () {}); }
        return fetchAlt.apply(this, arguments).then(function (r) {
          if (meine !== natNr) return veraltet();
          var textAlt = r.text;
          if (typeof textAlt === 'function') {
            r.text = function () {
              return textAlt.apply(r, arguments).then(function (t) { return meine === natNr ? t : veraltet(); },
                function (e) { if (meine === natNr) throw e; return veraltet(); });
            };
          }
          return r;
        }, function (e) { if (meine === natNr) throw e; return veraltet(); });
      };
    }
    /* Geleertes Feld oder Escape: noch laufende Vorschlags-Antworten gelten als veraltet. */
    input.addEventListener('input', function () { if (input.value.trim() === '') natNr++; });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') natNr++; }, true);
    ergebnisse = header.querySelector('.search__results');

    /* Ein echtes Antippen des Feldes kommt vor focus und click - damit ist die
       Flaeche sofort wieder da, ohne Wartezeit. */
    ['pointerdown', 'mousedown', 'touchstart'].forEach(function (n) {
      input.addEventListener(n, nachlaufAbbrechen, { capture: true, passive: true }); /* LB 168: passiv (PageSpeed), ruft nie preventDefault */
    });
    input.addEventListener('focus', function () { if (escFokus) { escFokus = false; return; } /* LB Update 253 (N2) */ if (input.value.trim() === '') oeffnen(); else if (desktop()) pruefen(); });
    input.addEventListener('click', function () { nachlaufAbbrechen(); if (input.value.trim() === '') oeffnen(); else if (desktop()) pruefen(); });
    /* LB 202: Ab jetzt zeigt am Desktop das eigene Fenster die Treffer (siehe oben). */
    document.documentElement.classList.add('lb-su-desk');
    input.addEventListener('input', pruefen);
    /* LB Update 291 (Auftrag F05): Escape leert ein type=search-Feld im Browser OHNE input-Ereignis (nur change/search).
       Dann gehoeren die Treffer/der Fehler im Fenster nicht mehr zur Eingabe - zuruecksetzen (oeffnet/sucht nichts). */
    input.addEventListener('search', function () { if (input.value.trim() === '') suZurueck(); });

    document.addEventListener('focusin', function (e) {
      if (offen && e.target !== input && !panel.contains(e.target)) schliessen();
    });

    // Klick ausserhalb schliesst - aber nie ueber blur, damit der Fokus bleibt
    document.addEventListener('pointerdown', function (e) {
      if (!offen) return;
      if (panel.contains(e.target) || header.contains(e.target)) return;
      schliessen();
    }, true);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && offen) schliessen();
    });
    /* LB Update 253 (N2): Nach Escape landete der Fokus auf <body> (das Theme ruft bei jedem Escape
       activeElement.blur() auf). Stand der Fokus im Suchfeld oder in der Vorschlagsflaeche, geht er jetzt
       zurueck aufs Suchfeld bzw. - wenn das Feld nicht bedienbar ist, oder am Handy - aufs Such-Symbol.
       Nur wenn der Fokus sonst auf <body> laege. Die Flaeche bleibt zu: kurze Sperre wie beim X, und der
       Fokus-Aufruf selbst oeffnet/sucht nicht. Sonst unveraendert. */
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || !(offen || (ergebnisse && ergebnisse.style.display === 'block' && ergebnisse.children.length))) return;
      var a = document.activeElement;
      if (!a || !(a === input || panel.contains(a))) return;
      setTimeout(function () {
        var jetzt = document.activeElement;
        if (jetzt && jetzt !== document.body && jetzt !== document.documentElement) return;
        function nutzbar(el) { return !!(el && el.getClientRects().length && !(el.closest && el.closest('[inert]'))); }
        var sym = [].slice.call(header.querySelectorAll('.js-search-header')).filter(nutzbar)[0];
        /* Das Inline-Skript der Kopfzeile (layout/theme.liquid) setzt die Suchleiste am Desktop nach Escape auf inert -
           dann ist das Such-Symbol das Ziel (oeffnet die Suche wieder). */
        var ziel = (!desktop() && sym) ? sym : (nutzbar(input) ? input : sym);
        if (!ziel) return;
        gesperrtBis = Date.now() + 300;
        if (ziel === input) escFokus = true;
        try { ziel.focus({ preventScroll: true }); } catch (_) {}
        escFokus = false;
      }, 0);
    }, true);

    // Das Lupen-Symbol am Handy oeffnet ebenfalls
    header.addEventListener('click', function (e) {
      if (e.target.closest('.js-search-header')) {
        nachlaufAbbrechen();
        setTimeout(function () { if (input.value.trim() === '') oeffnen(); }, 60);
      }
    });

    /* LB Update 152 (Sascha, 20.09.): Das X in der Suchleiste schliesst die
       Vorschlagsflaeche jetzt wirklich, und der Kunde sieht wieder die Seite,
       auf der er vorher war. Der Klick wird am Dokument in der Auffangphase
       abgefangen - das Suchfeld des Themes steckt in einem eigenen Element,
       das den Klick auf dem Weg nach oben abfaengt, deshalb kam er am
       Kopfbereich nie an. Die kurze Sperre verhindert, dass der Knopf den
       Fokus zurueckgibt und die Flaeche sofort wieder aufgeht. */
    document.addEventListener('click', function (e) {
      if (!e.target || !e.target.closest || !e.target.closest('.btn--close-search')) return;
      nachlaufAbbrechen();
      gesperrtBis = Date.now() + 300;
      suZurueck();
      if (input) {
        input.value = '';
        try { input.blur(); } catch (_) {}
      }
      schliessen();
      spaeterSchliessen(50);
      spaeterSchliessen(180);
    }, true);

    if ('ResizeObserver' in window) new ResizeObserver(anfordern).observe(header);

    /* LB Update 291 (Auftrag F05): Kommt die Verbindung zurueck, waehrend der Fehlerzustand offen steht, wird einmal neu abgerufen. */
    window.addEventListener('online', function () {
      if (offen && su.grid && su.grid.hasAttribute('data-lb-fehler')) nochmal();
    });

    /* LB 193: Vorladen im Leerlauf - und spaetestens beim ersten Beruehren des Feldes. */
    vorladenPlanen();
    ['pointerdown', 'touchstart', 'focus'].forEach(function (n) {
      input.addEventListener(n, vorladen, { once: true, passive: true });
    });

    // Wenn das Theme Treffer einblendet, treten wir zurueck
    if (ergebnisse) {
      new MutationObserver(function () {
        /* LB 189: zusaetzlich children.length - die Liste wird kurz vor dem
           Befuellen auf block gesetzt, und genau dann darf die Flaeche noch
           nicht weg. Gilt auch ohne Treffer: dann steht dort "Suche nach ...". */
        var sichtbar = ergebnisse.style.display === 'block' && ergebnisse.children.length;
        /* LB 202: Am Desktop zeigt das eigene Fenster die Treffer - nicht zuruecktreten. */
        if (desktop()) return;
        if (sichtbar && input.value.trim() !== '') schliessen();
      }).observe(ergebnisse, { attributes: true, attributeFilter: ['style'], childList: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();
